import { useContext, useState } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import useSEMSearchHeadline from '@/hooks/useSEMSearchHeadline'
import CONTENT, { GREETING_DESKTOP } from '@/constants/content'
import useCityNameInFormHeadlineForSEM from '@/hooks/useCityNameInFormHeadlineForSEM'
import { LOCATION_SEARCH_TYPE } from '@/types'

const getHeadlineWithFirstName = (template: string, firstName: string) =>
  firstName ? template.replace('{firstName}', firstName) : GREETING_DESKTOP

type HeadlineType = {
  headline: string
  subheadline?: string | undefined
}

type SearchFormProductHeadlineType = {
  hotels: HeadlineType
  flights: HeadlineType
  vacations: HeadlineType
  cars: HeadlineType
  cruises: HeadlineType
}

const useFormatHotelHeadlines = (
  values: SearchFormProductHeadlineType,
  hideNonSemHeadline: boolean
) => {
  const {
    customer: { firstName },
    signInStatus: { signedIn, passiveSignIn }
  } = useContext(BootstrapDataContext)

  const isSignedIn = signedIn || passiveSignIn

  const [location, setLocation] = useState<LOCATION_SEARCH_TYPE | undefined>()

  const SEMHeadline = useSEMSearchHeadline()
  const prePopHeadline = useCityNameInFormHeadlineForSEM(location)
  const headlineWithName = getHeadlineWithFirstName(
    CONTENT.homepage.vip.headlineWithName,
    firstName
  )
  const defaultHeadline = isSignedIn ? headlineWithName : values.hotels.headline
  const hotelHeadline =
    prePopHeadline ||
    SEMHeadline ||
    (hideNonSemHeadline ? null : defaultHeadline)

  return { hotelHeadline, setLocation }
}

export default useFormatHotelHeadlines
